import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import fileDownload from 'js-file-download';
import {
  MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_BEGIN,
  MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_SUCCESS,
  MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_FAILURE,
  MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_DISMISS_ERROR,
} from './constants';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';

export function downloadSubstitutionsFile(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/exportManageSubs`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_SUCCESS,
              data: res.data,
              priceRequired: args?.priceRequired,
            });
            resolve(res);
          } else if (res.status === 504) {
            const errorMsg = "Export file sent to email due to large volume of data";
            dispatch({
              type: MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_FAILURE,
              data: { error: errorMsg },
            });
            resolve(res);
          }
        },
        (err) => {
          let errorMsg;
          if (err && err.response && err.response.status === 504) {
            errorMsg = "Export file sent to email due to large volume of data";
          } else if (err && err.response && err.response.status !== 200 && err.response.status !== 504) {
            errorMsg = "Something went wrong";
          } else {
            errorMsg = 'There is an error. Please refresh page or contact administrator.';
          }
          dispatch({
            type: MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDownloadSubstitutionsFileError() {
  return {
    type: MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_DISMISS_ERROR,
  };
}

export function useDownloadSubstitutionsFile() {
  const dispatch = useDispatch();

  const { downloadSubstitutionsFilePending, downloadSubstitutionsFileError } = useSelector(
    state => ({
      downloadSubstitutionsFilePending: state.manageSubs.downloadSubstitutionsFilePending,
      downloadSubstitutionsFileError: state.manageSubs.downloadSubstitutionsFileError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(downloadSubstitutionsFile(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissDownloadSubstitutionsFileError());
  }, [dispatch]);

  return {
    downloadSubstitutionsFile: boundAction,
    downloadSubstitutionsFilePending,
    downloadSubstitutionsFileError,
    dismissDownloadSubstitutionsFileError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        downloadSubstitutionsFilePending: true,
        downloadSubstitutionsFileError: null,
      };

    case MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_SUCCESS:
      // The request is success
      if(!action?.priceRequired){
        fileDownload(action.data, `Substitution Reports.xlsx`);
      }
      return {
        ...state,
        downloadSubstitutionsFilePending: false,
        downloadSubstitutionsFileError: null,
      };

    case MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_FAILURE:
      // The request is failed
      return {
        ...state,
        downloadSubstitutionsFilePending: false,
        downloadSubstitutionsFileError: action.data.error,
      };

    case MANAGE_SUBS_DOWNLOAD_SUBSTITUTIONS_FILE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        downloadSubstitutionsFileError: null,
      };

    default:
      return state;
  }
}
